// src/components/ui/UploadProgressBar.jsx

/**
 * UploadProgressBar
 *
 * Displays an animated progress bar during file uploads.
 *
 * Props:
 *   progress  (number)  0–100. The aggregate upload percentage.
 *   label     (string)  Optional override label. Defaults to "Uploading… X%"
 *   className (string)  Extra Tailwind classes for the wrapper.
 *
 * Usage:
 *   <UploadProgressBar progress={uploadProgress} />
 */

import React from "react";

const UploadProgressBar = ({ progress = 0, label, className = "" }) => {
  const clamped = Math.min(100, Math.max(0, Math.round(progress)));
  const displayLabel = label ?? `Uploading… ${clamped}%`;

  return (
    <div className={`w-full space-y-1 ${className}`}>
      {/* Label row */}
      <div className="flex items-center justify-between">
        <p className="text-xs font-medium text-mikado-yellow animate-pulse">
          {displayLabel}
        </p>
        <p className="text-xs text-field-grey">{clamped}%</p>
      </div>

      {/* Track */}
      <div className="w-full h-2 rounded-full bg-dark-grey overflow-hidden">
        {/* Fill */}
        <div
          className="h-full rounded-full bg-mikado-yellow transition-all duration-200 ease-out"
          style={{ width: `${clamped}%` }}
        />
      </div>
    </div>
  );
};

export default UploadProgressBar;